import React from 'react'
import { Button } from '../../../lib/ui/button'
import CalendlyEventInfo from './CalendlyEventInfo'
import { cn } from '../../../lib/utils'
import { useBenefits } from '../../coach_services/BenefitsProvider'
import { useTranslation } from '../../../hooks/useTranslation'
import { ViewPreviousRequests } from './ServiceCard'
import SelectCalendlyEventInfo from './SelectCalendlyEventInfo'
import CandidateChangeFormatDialog from './CandidateChangeFormatDialog'

export default function MeetingInfo({
  calendlyEvent,
  eventName,
  requestType,
  buttonText,
  requestComplete,
  dashboardCard,
  cardTitle,
  flexResumeReview,
  meetingViaCalendly,
  buttonVariant,
  buttonUrl,
  hasCompletedReoccurringRequests,
  isIntroCard,
  isSelect,
  buttonStyles,
  serviceRequestsPageCard,
  ...props
}) {
  const { onScheduleClick, coach, select, resumeReview } = useBenefits()
  const { t } = useTranslation('service_card')

  const variant = select ? 'outline' : 'coachcta'
  const returnedStatus = resumeReview?.status === 'returned'

  const noShow = calendlyEvent?.service_request_no_show_id

  const showMeetingInfo =
    calendlyEvent && calendlyEvent['start_time'] && !noShow

  const SchedulingInfoComponent = isSelect
    ? SelectCalendlyEventInfo
    : CalendlyEventInfo

  if ((requestComplete || returnedStatus) && !flexResumeReview && !isSelect) {
    return (
      <div className="flex flex-col gap-4">
        <div
          className={cn(
            'flex items-center gap-4',
            dashboardCard ? 'w-full' : '',
          )}
        >
          <Button
            asChild
            variant={buttonVariant || variant}
            className={cn('', dashboardCard || isSelect ? 'w-full' : 'w-fit')}
          >
            <a
              href={buttonUrl}
              className={cn(
                'text-link',
                !select
                  ? 'text-white hover:text-white focus:text-white'
                  : isSelect
                    ? 'text-[#4E4E4E] hover:text-[#4E4E4E] focus:text-[#4E4E4E]'
                    : '',
              )}
            >
              {hasCompletedReoccurringRequests
                ? buttonText
                : t('view_feedback')}
            </a>
          </Button>
          <ViewPreviousRequests
            buttonUrl={buttonUrl}
            hasCompletedReoccurringRequests={hasCompletedReoccurringRequests}
            isIntroCard={isIntroCard}
          />
        </div>
      </div>
    )
  } else if (requestComplete && flexResumeReview) {
    return <></>
  } else if (showMeetingInfo) {
    return (
      <div className="flex flex-col gap-4">
        <div className={cn(isSelect ? '' : 'flex gap-4')}>
          <SchedulingInfoComponent
            eventName={eventName}
            calendlyEvent={calendlyEvent}
            dashboardCard={dashboardCard}
            buttonUrl={buttonUrl}
            buttonStyles={buttonStyles}
            resumeReview={resumeReview}
            isResumeReview={requestType === 'ServiceRequest::ResumeReview'}
            serviceRequestsPageCard={serviceRequestsPageCard}
            {...props}
          />
        </div>
        <ViewPreviousRequests isIntroCard={isIntroCard} />
      </div>
    )
  } else if (meetingViaCalendly === false) {
    return (
      <>
        <p className="!font-medium">{t('request_submitted_body')}</p>
        <ViewPreviousRequests isIntroCard={isIntroCard} />
      </>
    )
  } else {
    return (
      <div className="flex flex-col gap-4">
        <Button
          variant={buttonVariant || variant}
          onClick={() =>
            onScheduleClick(
              requestType,
              cardTitle,
              true,
              flexResumeReview ? 2 : 1,
            )
          }
          className={
            isSelect ? buttonStyles : cn('', dashboardCard ? 'w-full' : 'w-fit')
          }
          disabled={coach.isLiaison}
        >
          {buttonText}
        </Button>
        {flexResumeReview && <CandidateChangeFormatDialog />}
        <ViewPreviousRequests />
      </div>
    )
  }
}
